<app-modal-wrapper [title]="'feature.playlist.create' | translate" (closeAction)="close()">
  <form modalBody [formGroup]="createPlaylistForm" (ngSubmit)="onSubmit()">
    <div>
      <div class="form-group">
        <label for="playlist">{{ 'common.label.title' | translate }}</label>
        <div class="input-group">
          <input id="playlist" class="form-control" [placeholder]="'feature.playlist.title_hint' | translate" formControlName="title" />
        </div>
      </div>
    </div>
  </form>
  <ng-container modalFooter>
    <button (click)="onSubmit()" [disabled]="loading || this.createPlaylistForm.invalid" class="btn btn-primary rounded-pill mx-1">
      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>{{ 'common.button.save' | translate }}
    </button>
  </ng-container>
</app-modal-wrapper>
